import React, { useState } from 'react';
import { Row, Col } from "react-bootstrap";
import referfriendImg from "../../assets/panelImages/ReferFriend/referFriend.svg";
import copy from "../../assets/panelImages/ReferFriend/copy.svg";

const ReferFriend = () => {
  const [copied, setCopied] = useState(false);
  const referralLink = 'https://torfacts.com?refer=cmVmJTIxZTlkZjA1YjY1NzFjNmM1YzM5NzQ2MDQyZWQ2ZThmNGI=';

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(referralLink);
      setCopied(true);

      // Hide "Copied!" after 30 seconds
      setTimeout(() => {
        setCopied(false);
      }, 30000);
    } catch (err) {
      setCopied(false);
      console.error("Failed to copy text: ", err);
    }
  };

  return (
    <div className="mt-2">
      <h2 className="page-main-title">Refer Friend</h2>
      <div className="bg-white p-4 rounded shadow flex gap-4 flex-wrap">
        <Row>
          <Col lg={8} md={8} sm={8} xs={12}>
            <img src={referfriendImg} className='rf-img' alt="Refer a Friend" />
          </Col>
          <Col lg={4} md={4} sm={4} xs={12}>
            <h3 className='rf-heading'>Refer a Friend and Get Rewarded</h3>
            <hr className='short-separator' />
            <ul className='key-points'>
              <li>Invite a friend to Torfacts.</li>
              <li>Friend successfully signs up on Torfacts.</li>
              <li>You get 1000 points.</li>
            </ul>
          </Col>
        </Row>

        <h4 className='invite-text'>Invite a friend now!</h4>
        <p className="rlink">
          <input
            id="myInput"
            type="text"
            readOnly
            value={referralLink}
          />
          <a title="Copy to Clipboard" onClick={handleCopy} style={{ cursor: 'pointer' }}>
            <img src={copy} className='copylink' alt="Copy Link" />
          </a>
        </p>

        {copied && <p className="copied">Copied!</p>}
      </div>

      <div className="bg-white p-4 mt-4 rounded shadow flexuio7 gap-4 flex-wrap">
        <h3 className='rf-heading'>How "Refer a Friend" will benefit you:</h3>
        <ul className='key-points mt-3'>
          <li><p className='rf-benefits'>Please share the link provided above with your referrals.</p></li>
          <li><p className='rf-benefits'>You can refer as many people as you want. Once 5 of your referrals verify their account and start survey activity, your earned referral points will be added to your account.</p></li>
          <li><p className='rf-benefits'>You get 1000 points each for successful (with verified email account and survey activity) referral.</p></li>
          <li><p className='rf-benefits'>The points will be earned in two stages, 500 on email verification and 500 on survey activity by your referral.</p></li>
          <li><p className='rf-benefits'>After 5 successful referrals, the referral link will get disabled.</p></li>
        </ul>
      </div>
    </div>
  );
};

export default ReferFriend;
